import pick from 'lodash/pick';
import without from 'lodash/without';
import find from 'lodash/find';

export const modals = (state = [], action) => {
  switch (action.type) {
    case 'SHOW_MODAL': return [pick(action, 'id', 'options', 'onClose'), ...state];
    case 'DESTROY_MODAL': return without(state, find(state, ['id', action.id]));
    default: return state;
  }
};
